<template>

  <div class="divcss5 body-width">
    <section>
      <aboutpartcontent></aboutpartcontent>
    </section>
    <section >
      <productpartcontent style="margin-top: -120px"></productpartcontent>
    </section>
    <section  >
      <newspartcontent ></newspartcontent>
    </section>
    <section  >
      <joinpartcontent ></joinpartcontent>
    </section>
    <section >
      <partnerpartcontent></partnerpartcontent>
    </section>
    <section >
      <contactpartcontent class="pad_botom_50"></contactpartcontent>
    </section>
  </div>
</template>
<script>
import banner from "@/components/commoncoms/banner";
import aboutpartcontent from "@/components/contentcoms/indexcontentcoms/aboutpartcontent";
import productpartcontent from "@/components/contentcoms/indexcontentcoms/productpartcontent";
import newspartcontent from "@/components/contentcoms/indexcontentcoms/newspartcontent";
import joinpartcontent from "@/components/contentcoms/indexcontentcoms/joinpartcontent";
import partnerpartcontent from "@/components/contentcoms/indexcontentcoms/partnerpartcontent";
import contactpartcontent from "@/components/contentcoms/indexcontentcoms/contactpartcontent";
  export default {
    components: {
      contactpartcontent,
      partnerpartcontent,
      joinpartcontent,
      newspartcontent,
      productpartcontent,
      aboutpartcontent,
      banner,
    },
    name: "indexcontent",
    methods:{
      setroters(src){
        this.$router.push(src);
      },
     }
  }
</script>

<style scoped>
  .pad_botom_50{
    padding-bottom: 50px;
  }
</style>




// WEBPACK FOOTER //
// src/components/contentcoms/indexcontentcoms/indexcontent.vue